import type { AnalyticsDataSource } from '../types/analytics';
import { ApiAnalyticsDataSource } from './apiDataSource';
import { MockAnalyticsDataSource } from './mockDataSource';

export function createDataSource(mode: string | undefined = import.meta.env.VITE_ANALYTICS_DATA_SOURCE, getAccessToken?: () => Promise<string | null>): AnalyticsDataSource {
  if (mode === 'api') return new ApiAnalyticsDataSource(import.meta.env.VITE_ANALYTICS_API_BASE_URL || '/api/analytics', getAccessToken);
  if (mode === 'mock' || (!mode && import.meta.env.DEV)) return new MockAnalyticsDataSource();
  throw new Error('VITE_ANALYTICS_DATA_SOURCE must be explicitly set to api or mock. Production never falls back to mock data.');
}
